import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  author: {
    fontWeight: theme.typography.fontWeightMedium
  },
  edited: {
    fontStyle: 'italic'
  }
}));

const displayNameOf = actionUser =>
  (actionUser && (actionUser.displayName || actionUser.userName)) || 'Unknown';

const formatTime = time =>
  `${moment(time).format('MMM Do YYYY, h:mm a')} (${moment(time).fromNow()})`;

const NoteAttribution = props => {
  const { note, className } = props;

  const classes = useStyles();

  return (
    <div className={className}>
      <Typography variant="body2" color="textSecondary">
        <span className={classes.author}>{displayNameOf(note.createdBy)}</span>{' '}
        — {formatTime(note.createdTime)}
      </Typography>
      {note.lastUpdatedTime && (
        <Typography
          className={classes.edited}
          variant="body2"
          color="textSecondary">
          Edited by {displayNameOf(note.lastUpdatedBy)} —{' '}
          {formatTime(note.lastUpdatedTime)}
        </Typography>
      )}
    </div>
  );
};

NoteAttribution.propTypes = {
  className: PropTypes.string,
  note: PropTypes.object.isRequired
};

export default NoteAttribution;
